export function Field({ label, hint, error, children, required = false }) {
  return <label className="block space-y-2">
    <span className="flex items-center justify-between text-[10px] font-bold uppercase tracking-[.15em] text-slate-400"><span>{label}{required && <b className="ml-1 text-cyan-300">*</b>}</span>{hint && <span className="normal-case tracking-normal text-slate-600">{hint}</span>}</span>
    {children}
    {error && <span className="block text-xs text-rose-300">{error}</span>}
  </label>;
}
